module.exports = __webpack_public_path__ + "img/chips200.4cb474c4.webp";